import React, {Component} from 'react';

const jQuery = window.jQuery,
	$ = jQuery;

// WOW = window.WOW;

class ScrollSection extends Component {

	componentWillMount() {
		(function($) {
			$.fn.scrollingTo = function(opts) {
				let defaults = {
					animationTime           : 1000,
					easing                  : '',
					topSpace                : 0,
					callbackBeforeTransition: function() {
					},
					callbackAfterTransition : function() {
					}
				};

				let config = $.extend({}, defaults, opts);

				$(this).on('click', function(e) {
					let eventVal = e;
					e.preventDefault();

					let $section = $(document).find($(this).data('section'));
					if ($section.length < 1) {
						return false;
					}

					let $html = $('html, body');
					if ($html.is(':animated')) {
						$html.stop(true, true);
					}

					let scrollPos = $section.offset().top;

					if ($(window).scrollTop() === (scrollPos + config.topSpace)) {
						return false;
					}

					config.callbackBeforeTransition(eventVal, $section);

					let newScrollPos = (scrollPos - config.topSpace);

					$html.animate({
						'scrollTop': (newScrollPos + 'px')
					}, config.animationTime, config.easing, function() {
						config.callbackAfterTransition(eventVal, $section);
					});

					return $(this);
				});

				$(this).data('scrollOps', config);
				return $(this);
			};
		}(jQuery));

		window.scrollDirection = null;

		/*
		new WOW({
			offset: 200,
			mobile: false
		}).init();
		*/

	}

	componentDidMount() {
		(function() {
			let sections = $(".scroll-section");

			function getActiveSectionLength(section, sections) {
				return sections.index(section);
			}

			if (sections.length > 0) {

				sections.waypoint({
					handler: function(direction) {
						let active_section, active_section_index, prev_section_index;
						active_section = $('#' + this.element.id);
						active_section_index = getActiveSectionLength(active_section, sections);
						prev_section_index = (active_section_index - 1);

						if (direction === "up") {
							window.scrollDirection = "up";
							if (prev_section_index >= 0) {
								active_section = sections.eq(prev_section_index);
							}
						} else {
							window.scrollDirection = "Down";
						}

						// if (active_section.attr('id') !== 'home') {
						let active_link = $('.menu-smooth-scroll a[href="#' + active_section.attr('id') + '"]');
						active_link.parent('li').addClass("active").siblings().removeClass("active");
						// } else {
						// 	$('.menu-smooth-scroll').parent('li').removeClass('active');
						// }
					},
					offset : '35%'
				});
			}

		}());

		/*================================
			 jquery smooth scroll
			 ==================================*/

		$('.smooth-scroll, .wlcome-btn a.smooth-scroll, .logo a, .menu-smooth-scroll a').scrollingTo({
			easing                  : 'easeOutQuart',
			animationTime           : 1800,
			topSpace                : 63,
			callbackBeforeTransition: function(e) {
				if (e.currentTarget.hash !== "") {
					if (e.currentTarget.hash !== '#home') {
						$(e.currentTarget).parent().addClass('current').siblings().removeClass('current');
					}
				}

				$('.button-collapse').sideNav('hide');
			},
			callbackAfterTransition : function(e) {
				if (e.currentTarget.hash !== "") {
					if (e.currentTarget.hash === '#home') {
						window.location.hash = '';
					} else {
						window.location.hash = e.currentTarget.hash;
					}

				}
			}
		});

		$('.menu-smooth-scroll').scrollingTo({
			easing                  : 'easeOutQuart',
			animationTime           : 1800,
			callbackBeforeTransition: function(e) {
				if (e.currentTarget.hash !== "") {
					if (e.currentTarget.hash !== '#home') {
						$(e.currentTarget).parent().addClass('current').siblings().removeClass('current');
					}
				}

				$('.button-collapse').sideNav('hide');
			},
			callbackAfterTransition : function(e) {
				if (e.currentTarget.hash !== "") {
					if (e.currentTarget.hash === '#home') {
						window.location.hash = '';
					} else {
						window.location.hash = e.currentTarget.hash;
					}

				}
			}
		});

		/*======================================
		 jquery scroll spy
		 ========================================*/
		jQuery("body").scrollspy({

			target: ".navbar-collapse",
			offset: 95

		});

		/*=============================
			 NiceScroll
			 ==============================*/
		/*
		$("html").niceScroll({
			scrollspeed       : 60,
			mousescrollstep   : 40,
			cursorwidth       : 7,
			cursorborder      : 0,
			cursorcolor       : '#00a99d',
			autohidemode      : true,
			zindex            : 999999999,
			horizrailenabled  : false,
			cursorborderradius: 0
		});
		*/
	}

	render() {
		const {children} = this.props;
		return (
			<main>
				{children}
			</main>
		);
	}
}

export default ScrollSection;



// WEBPACK FOOTER //
// ./src/components/containers/ScrollSection.js